import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Utils from 'common/utils'
import Constants from 'common/constants'
import LocationStringManager from 'manager/locationStringManager'

export default class LocationNotificationView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            locationString: this.getLocationString(props.location, props.defaultLocationString)
        }
        this.observer = null
    }

    componentDidMount() {
        // Add animation related entries
        this.addLocStrObserver()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        var shouldUpdateLocStr = false;
        if (prevProps.defaultLocationString !== this.props.defaultLocationString) {
            shouldUpdateLocStr = true;
        } else {
            // Check for location changes
            if (Utils.isNull(prevProps.location) && Utils.isNull(this.props.location)) {
                shouldUpdateLocStr = false;
            } else if (Utils.isNull(prevProps.location) || Utils.isNull(this.props.location)) {
                shouldUpdateLocStr = true;
            } else {
                shouldUpdateLocStr = (
                    prevProps.location.area !== this.props.location.area ||
                    prevProps.location.city !== this.props.location.city
                )
            }
        }

        if (shouldUpdateLocStr) {
            this.setState({
                locationString: this.getLocationString(this.props.location, this.props.defaultLocationString)
            })
        }
    }

    render() {
        return (
            <div className="user-loc-string truncate-long-text location-string">
                {this.state.locationString}
            </div>
        )
    }

    getLocationString(location, defaultLocationString) {
        var city = null;
        var area = null;
        if (false === Utils.isNull(location)) {
            city = location.city
            area = location.area
        }

        let locStr = LocationStringManager.getLocationString(area, city, defaultLocationString)
        if (Utils.isNull(locStr)) {
            locStr = Constants.DEFAULT_AREA_STR;
        }
        return locStr
    }

    addLocStrObserver() {
        console.log("LOCATION_STR: Add observer")
        var locEntries = document.getElementsByClassName("location-string")
        if (Utils.isNull(locEntries) || locEntries.length === 0) {
            console.log("Cannot find location-string element for adding observer")
            return
        }

        var locStrElement = locEntries.item(0)
        if (Utils.isNull(locStrElement)) {
            console.log("Cannot find location-string target for adding observer")
            return
        }

        // Add observer
        this.clearObserver()
        this.observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === "characterData") {
                    console.log("LOCATION_STR: ", mutation);
                    // Perform animation
                    var animationClass = "location-animation"
                    locStrElement.classList.add(animationClass)
                    setTimeout(() => {
                        locStrElement.classList.remove(animationClass)
                    }, 1000)
                }
            });
        });
        var config = { attributes: false, childList: false, characterData: true, subtree: true }
        this.observer.observe(locStrElement, config);
    }

    clearObserver() {
        if (false === Utils.isNull(this.observer)) {
            this.observer.disconnect()
            this.observer = null;
        }
    }
}

LocationNotificationView.propTypes = {
    location: PropTypes.any.isRequired,
    defaultLocationString: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/locationNotificationView.js